// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Y5K1","inputDescription":"styles_inputDescription__2YexS"};